module.exports = __webpack_public_path__ + "img/Kelantan.38d504cc.png";